import React, { Component } from "react";
import logo from "../../img/logosine.png";
import { NavLink } from "react-router-dom";
// import "./login.css";
import { BehaviorSubject } from 'rxjs';
import "../sidebar/common.css";
export default class Massage extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  handleLoginClick = () => {
    let currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);

  };
  componentDidMount() {
    
  }
  render() {
    return (
      <div>
        <section className="login">
          <div className="login_part">
            <div className="sing_log">
              <div className="sing_one">
                <img src={logo} alt="logo" />
              </div>
              <div className="text_sing mb-4">
                <p className="faster_oval"></p>
                <h4 className="Account">Verify your Email Address</h4>
                <p className="massage">To verify your email and continue the registration process, kindly click the link that was just delivered to your inbox.</p>
                
                  <p>If your are already Verified, then click on Login Button.</p>
                <div className="global d-flex justify-content-center m-3">
                    <NavLink onClick={this.handleLoginClick} className="page_width page_save button_color" to="/login">
                      Login
                    </NavLink>
                  </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
